// @ts-nocheck
import { useEffect } from 'react'
import styles from '../assets/scss/components/store-locator.module.scss'
import { classNames } from '@shopify/css-utilities'

export const StoreLocator: React.FC = () => {
  useEffect(() => {
    ;(function (s, t, o, c, k) {
      c = s.createElement(t)
      c.src = o
      c.async = 1
      k = s.getElementsByTagName(t)[0]
      k.parentNode.insertBefore(c, k)
    })(document, 'script', '//stockist.co/embed/v1/widget.min.js')
  }, [])

  return (
    <section className={classNames('section', 'px')}>
      <div className={styles.storeLocator}>
        <div data-stockist-widget-tag="u22825">
          Loading store locator from <a href="https://stockist.co">Stockist store locator</a>...
        </div>
      </div>
    </section>
  )
}
